import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DEFAULT_CURRENCY_CODE } from '@constants/currency';
import { BillItemPendingModel } from '@data-layer/models/payments';
import { enumBillItemProductCode } from '@data-layer/enums/payments';
import { enumBillItemUnit } from '@data-layer/enums/lcl';

@Component({
  selector: 'view-charges-mobile',
  templateUrl: './view-charges-mobile.component.html',
  styleUrls: ['./view-charges-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewChargesMobileComponent {
  @Input() public masterGroups: Array<{ key: string; items: BillItemPendingModel[] }>;
  @Input() public secondaryGroups: Array<{ key: string; items: BillItemPendingModel[] }>;
  @Input() public totalSum: number;
  @Input() public isPaid: boolean;
  @Input() public totalFieldKey: string;

  public DEFAULT_CURRENCY_CODE: typeof DEFAULT_CURRENCY_CODE = DEFAULT_CURRENCY_CODE;
  public EXPORT_LICENSE_CODE: string = enumBillItemProductCode.EXPORT_LICENSE;

  constructor() {}

  public getSumMasterGroup(group: BillItemPendingModel[]): number {
    return (group || []).reduce((acc: number, current: BillItemPendingModel) => acc + current?.price, 0);
  }

  public getSumAdditionalGroup(group: BillItemPendingModel[]): number {
    return (group || []).reduce((acc: number, current: BillItemPendingModel) => acc + current?.price * current?.quantity, 0);
  }

  public itemQuantityLabel(unit: enumBillItemUnit): string {
    switch (unit) {
      case enumBillItemUnit.CBM:
        return 'LENGTH_UNIT.CBM';
      case enumBillItemUnit.HBL:
        return 'LABELS.HBL';
      case enumBillItemUnit.TON:
        return 'WEIGHT_UNIT.TON';
      default:
        return '';
    }
  }
}
